const formatIntlMessage = (key: string): string => (
  key.split('_').join(' ').split('.').join(' ')
);

const getIntlMessage = (
  prefix: string,
  page: string,
  kind: string,
  key?: string,
): string => {
  let intlMessage: string;

  if (!key) {
    intlMessage = formatIntlMessage(`${prefix} ${page} ${kind}`);
  } else {
    intlMessage = formatIntlMessage(`${prefix} ${page} ${kind} ${key}`);
  }

  return intlMessage;
};

export {
  formatIntlMessage,
  getIntlMessage,
};
